import { Avatar, Button, Input, List, message, Modal, Radio, Select, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import useBoolean from '../../../Utils/useBoolean';
import { DeleteOutlined, MailOutlined, PlusOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { fetchInvoiceParams } from '../../../Reducers/balance';
import CreateInvoiceToDrawer from './CreateInvoiceToDrawer';
import './styles.scss'
import useUpdateCustomerSettings from '../../../Utils/useUpdateCustomerSettings';

const { Option } = Select;

const CustomerSettingsModal = ( { showButton = false }) => {

  const [company, setCompany] = useState(null);
  const [isAddingEmail, setIsAddingEmail] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const { value: isOpen, setFalse: close, setTrue: open } = useBoolean(false);

  const payloadCustomer = useSelector(
      (state) => state.core.customer.id,
      shallowEqual
    );

  const dispatch = useDispatch();
  const updateCustomerSettings = useUpdateCustomerSettings();

  useEffect(() => {
    dispatch(fetchInvoiceParams())
  }, [payloadCustomer])

  const { payload, isLoading } = useSelector(state => 
    state.balance.getParams, shallowEqual
  );

  const handleSelectChange = (id) => {
    setCompany(id)
  };

  const handleAddEmailClick = () => {
    setIsAddingEmail(true);
  };

  const handleEmailChange = (e) => {
    setNewEmail(e.target.value);
  };

  const handleEmailSubmit = () => {
    if (newEmail.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation
      if (!emailRegex.test(newEmail.trim())) {
        message.error('Please enter a valid email address');
        return;
      }
  
      const updatedEmails = [...(payload.orderEmail || []), newEmail.trim()];
      updateCustomerSettings({ orderEmail: updatedEmails });
  
      setNewEmail('');
      setIsAddingEmail(false);
    }
  };

  const handleDeleteEmail = (email) => {
    if (!payload?.orderEmail) return;
  
    let updatedEmails = payload.orderEmail.filter(e => e !== email);
  
    // console.log(`UPDATED: ${updatedEmails}`);
    updateCustomerSettings({ orderEmail: updatedEmails });
  };

  const handleSaveParams = (value) => {
    // console.log(`INV_VAL: ${value}`)

    updateCustomerSettings(value);
    // updateCustomerSettings(value)
  }

  return (
    <>
    {showButton ? <Button className="openSettings_btn" type="primary" onClick={open}>Settings</Button> : <Avatar onClick={open} style={{ backgroundColor: 'rgb(131, 73, 246)' }} icon={<UserOutlined />} />}
    <Modal
      title="Customer settings"
      width="90vw"
      destroyOnClose
      open={isOpen}
      // onCancel={close}
      // onOk={onOk}
      closable={false}
      maskClosable
      footer={[
              <Button key="back" onClick={close}>
                Return
              </Button>
            ]}
      >

    <div className='companies'>
    <Radio.Group
      block
      options={[
        { label: 'PRE PAY', value: 'PRE_PAY' },
        { label: 'POST PAY', value: 'POST_PAY' },]}
      defaultValue={payload?.sendOrderMode !== null ? payload?.sendOrderMode : null}
      optionType="button"
      buttonStyle="solid"
      onChange={(e) => handleSaveParams({sendOrderMode: e.target.value})}
    />

    <List
      loading={isLoading}
      header={<h3>Customer emails <MailOutlined /></h3>}
      footer={
        <Button icon={<PlusOutlined />} onClick={handleAddEmailClick}>
          Add email
        </Button>
      }
      bordered
      dataSource={[...(payload?.orderEmail || []), ...(isAddingEmail ? [''] : [])]}
      // dataSource={payload?.orderEmail !== null ? payload?.orderEmail  : []}
      renderItem={(item, index) => (
        <List.Item className='company_item'>
          {isAddingEmail && index === payload?.orderEmail?.length ? (
            <Input
              autoFocus
              value={newEmail}
              onChange={handleEmailChange}
              onPressEnter={handleEmailSubmit}
              onBlur={() => setIsAddingEmail(false)}
              placeholder="Enter email"
            />
          ) : (
            <div>
              {item} 
              <Button className="company_btns__btn" onClick={() => handleDeleteEmail(item)} icon={<DeleteOutlined />} />
            </div>
          )}
        </List.Item>
      )}
    />
    

    <List
      loading={isLoading}
      header={<h3>Companies info <TeamOutlined /></h3>}
      footer={<CreateInvoiceToDrawer companyId={null} companyPayload={payload?.invoiceTo} setCompany={setCompany} />}
      bordered
      dataSource={payload?.invoiceTo ? payload?.invoiceTo : []}
      renderItem={(item) => (
        <List.Item className='company_item'>
          <Typography.Text mark>[{item.id}]</Typography.Text> {item.toName} 
          <CreateInvoiceToDrawer 
          payload={payload} 
          companyId={item.id} 
          companyPayload={payload.invoiceTo} 
          setCompany={setCompany}
          />
        </List.Item>
      )}
    />

        {/* <Select onChange={handleSelectChange} placeholder="Select a company">
          {payload?.map((option) => (
            <Option key={option.id} value={option.id}>
              {option.name}
            </Option>
          ))}
        </Select> */}
        
        </div>
    </Modal>
    </>
  )
}

export default CustomerSettingsModal
